  <template>
    <div class="dashboard-wrapper py-2">

      <div class="container-fluid" style="background-color: #f6f7fa" :class="{ blurred: isLoading }">
        <!-- Header -->
        <b-card class="shadow header-card">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h1 class="font-weight-bold mb-1">{{ merchantData.merchant }}</h1>
              <span class="h5 font-weight-bold">Selamat datang di ringkasan keuangan</span>
            </div>
            <b-badge variant="light" pill class="px-3 py-2 font-weight-semibold text-dark">
              Merchant Dashboard
            </b-badge>
          </div>
        </b-card>

        <div class="customer-metrics-grid">
          <!-- Sales Card -->
          <b-card class="metric-card">
            <div class="d-flex flex-column">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h2 class="section-title">Penjualan</h2>
                <b-avatar src="@/assets/images/icons/financial-sale.png" variant="light" size="4em" rounded />
              </div>
              <div class="mt-auto mb-auto">
                <small class="metric-label d-flex mb-2">
                  <span style="font-size: 2.3rem; margin-right: 1rem;">{{ formatNumber(merchantData.total_invoice)
                    }}</span>
                  <div class="d-flex flex-column">
                    <small style="font-size: 1.5rem;">Total Nota</small>
                    <small style="font-size: 1rem;">{{ formatCurrency(merchantData.sales)
                      }}</small>
                  </div>
                </small>
                <small class="metric-label d-flex align-items-center mb-2">
                  <span style="font-size: 2.3rem; margin-right: 1rem;">
                    {{ formatNumber(
                    (Number(merchantData.total_invoice) || 0) -
                    (Number(merchantData.pelangganTidakTerdaftar) || 0)
                    ) }}</span>
                  <div class="d-flex flex-column">
                    <small style="font-size: 1.15rem;">Pelanggan ({{
                      isNaN(merchantData.totalValuePelangganTerdaftar / merchantData.sales * 100)
                      ? 0
                      : Math.round(merchantData.totalValuePelangganTerdaftar / merchantData.sales * 100)
                      }} %)</small>
                    <small style="font-size: 1rem;">{{ formatCurrency(merchantData.totalValuePelangganTerdaftar)
                      }}</small>
                  </div>
                </small>
                <!-- PELANGGAN TIDAK TERDAFTAR -->
                <small class="metric-label d-flex align-items-center">
                  <span style="font-size: 2.3rem; margin-right: 1rem;">
                    {{ formatNumber(merchantData.pelangganTidakTerdaftar) }}</span>
                  <div class="d-flex flex-column">
                    <small style="font-size: 1.15rem;">
                      Non Pelanggan ({{
                      isNaN(merchantData.totalValuePelangganTidakTerdaftar / merchantData.sales * 100)
                      ? 0
                      : Math.round(merchantData.totalValuePelangganTidakTerdaftar / merchantData.sales * 100)
                      }}%)</small>
                    <small style="font-size: 1rem;">{{ formatCurrency(merchantData.totalValuePelangganTidakTerdaftar)
                      }}</small>
                  </div>
                </small>
              </div>
            </div>
          </b-card>

          <!-- Customer Card -->
          <b-card class="metric-card" body-class="d-flex flex-column">
            <div class="d-flex justify-content-between align-items-center">
              <h2 class="section-title">Pelanggan</h2>
              <b-avatar src="@/assets/images/icons/financial-relation.png" variant="light" size="48px" rounded />
            </div>
            <div class="d-flex flex-column align-items-center mt-auto">
              <div class="mb-4" style="font-size: 4rem; font-weight: 800;">{{ merchantData.persenPelangganAktif }} %
              </div>
                <h4 class="metric-value">
                  {{ merchantData.pelangganTerdaftar }} / {{ merchantData.totalPelangganTerdaftar }}
                </h4>
              <small style="font-size: 1rem; text-align: center;">Pelanggan yang berbelanja / Total Pelanggan</small>
              <div @click="openModalCustomerFinancial" style="cursor: pointer; text-align: end;">Lihat Detail</div>
            </div>
          </b-card>

          <!-- Income Card -->
          <b-card class="metric-card">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h2 class="section-title">Pendapatan</h2>
              <b-avatar src="@/assets/images/icons/financial-income.png" variant="light" size="48px" rounded />
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span>Sales / Omset</span>
              <span class="font-weight-bold">{{ formatCurrency(merchantData.sales) }}</span>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span>Harga Pokok Penjualan (HPP)</span>
              <span class="font-weight-bold">{{ formatCurrency(merchantData.stock) }}</span>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span>Laba Kotor <b-badge variant="success" pill class="badge-white-text">{{
                  merchantData.persenGrossProfit }}%</b-badge></span>
              <span class="font-weight-bold text-success">{{ formatCurrency(merchantData.grossProfit) }}</span>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span>Pengeluaran Lainnya</span>
              <span class="font-weight-bold text-danger">{{ formatCurrency(merchantData.cost) }}</span>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span>Laba Bersih <b-badge variant="info" pill class="badge-white-text">{{
                  merchantData.persenNetProfit }}%</b-badge></span>
              <span class="font-weight-bold text-info">{{ formatCurrency(merchantData.netProfit) }}</span>
            </div>
          </b-card>
        </div>

        <!-- Inventory in cash Card-->
        <!-- <b-row class="mb-3 cost-card-section">
          <b-col class="d-flex">
            <b-card class="shadow-lg metric-section w-100 h-100">
              <div class="d-flex justify-content-between align-items-center">
                <h2 class="section-title">Nilai Stok</h2>
                <b-avatar src="@/assets/images/icons/financial-inventory.png" variant="light" size="48px" rounded />
              </div>
              <div class="d-flex justify-content-center align-items-center flex-grow-1">
                <div class="text-success text-center m-0" style="font-weight: 900; font-size: 2rem;">
                  {{ formatCurrency(merchantData.inventory_cash_value) }}
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row> -->

        <!-- Cost Card -->
        <b-row class="mb-3 cost-card-section">
          <b-col class="d-flex">
            <b-card class="shadow-lg metric-section w-100 h-100">
              <div class="d-flex justify-content-between align-items-center">
                <h2 class="section-title">Pengeluaran Lainnya</h2>
                <b-avatar src="@/assets/images/icons/financial-cost.png" variant="light" size="48px" rounded />
              </div>
              <div class="d-flex justify-content-center align-items-center flex-grow-1">
                <div class="text-danger text-center m-0" style="font-weight: 900; font-size: 2rem;">
                  {{ formatCurrency(merchantData.cost) }}
                </div>
              </div>
              <div v-if="merchantData.groupedPayments && Object.keys(merchantData.groupedPayments).length"
                class="grouped-payments">
                <small class="mt-3 mb-1" style="font-size: 1.5rem; color: black; font-weight: bold;">Rincian</small>

                <div v-for="(tipe, tipeName) in merchantData.groupedPayments" :key="tipeName" class="m-0 p-0">
                  <b-card no-body class="m-0 p-0 border-0">
                    <!-- Level 1 -->
                    <b-card-header class="p-1 m-0" style="cursor: pointer;" @click="toggleTipe(tipeName)">
                      <div class="d-flex justify-content-between align-items-center w-100">
                        <div class="d-flex align-items-center flex-shrink-1">
                          <h3 class="mb-0 text-truncate"><strong>{{ tipeName }}</strong></h3>
                          <b-icon icon="chevron-right" class="ml-1 transition"
                            :class="{ 'rotate-90': expandedTipe.includes(tipeName) }" />
                        </div>
                        <div class="font-weight-bold flex-shrink-0 text-right">
                          {{ formatCurrency(tipe.total_amount) }}
                        </div>
                      </div>
                    </b-card-header>

                    <!-- Level 2 -->
                    <div v-show="expandedTipe.includes(tipeName)" class="pl-2 m-0">
                      <div v-for="(jenis, jenisName) in tipe.jenis_pembayaran" :key="jenisName" class="m-0 p-0">
                        <b-card no-body class="m-0 p-0 border-0">
                          <b-card-header class="p-1 m-0" style="cursor: pointer;"
                            @click="toggleJenis(tipeName, jenisName)">
                            <div class="d-flex justify-content-between align-items-center w-100">
                              <div class="d-flex align-items-center flex-shrink-1">
                                <h4 class="mb-0 text-truncate"><strong> {{ jenisName }}</strong></h4>
                                <b-icon icon="chevron-right" class="ml-1 transition"
                                  :class="{ 'rotate-90': isJenisExpanded(tipeName, jenisName) }" />
                              </div>
                              <div class="flex-shrink-0 text-right">
                                {{ formatCurrency(jenis.total_amount) }}
                              </div>
                            </div>
                          </b-card-header>

                          <!-- Level 3 -->
                          <div v-show="isJenisExpanded(tipeName, jenisName)" class="pl-3 m-0">
                            <div v-for="(detail, i) in jenis.details" :key="i"
                              class="d-flex justify-content-between align-items-center w-100 m-0 p-0">
                              <h5 class="mb-0 text-truncate">{{ detail.detail ? detail.detail : '-' }}</h5>
                              <span class="flex-shrink-0 text-right mr-1">
                                {{ formatCurrency(detail.total_amount) }}
                              </span>
                            </div>
                          </div>
                        </b-card>
                      </div>
                    </div>
                  </b-card>
                </div>

              </div>

            </b-card>
          </b-col>

        </b-row>

        <!-- UTANGPIUTANGSECTION -->
        <div class="utang-piutang-section">
          <!-- Utang Card -->
          <b-card class="mb-0 border-10 p-2">
            <h2 class="text-dark fw-bold-700">Utang</h2>

            <!-- Total Utang -->
            <div class="mb-1">
              <div class="tooltip-wrapper" @mouseenter="showTooltip.utang_total = true"
                @mouseleave="showTooltip.utang_total = false">
                <h6>Total Kumulatif <feather-icon icon="AlertCircleIcon" /></h6>
                <Transition name="fade">
                  <div v-if="showTooltip.utang_total" id="talkbubble">
                    <div class="content-tooltip">
                      Akumulasi Utang sampai dengan tanggal {{ moment(filterDate.to).format("DD MMM YYYY") }}
                    </div>
                  </div>
                </Transition>
              </div>
              <b-progress :value="utang_piutang.utang_total_percentage" max="100" height="8px" variant="danger"
                class="mt-25 mb-25" style="background-color: #ffe5d3" />
              <h4 class="text-left fw-bold text-dark">
                {{ formatCurrency(utang_piutang.utang_total) }}
              </h4>
              <div class="d-flex text-decoration-none">
                <router-link :to="{ name: 'debt.index', query: { from: $route.name, type: 'Utang', period: 4 } }"
                  target="_blank" class="flex-grow-1 text-dark d-flex justify-content-between link-hover">
                  <h5 class="mb-1 ml-1">{{ formatCurrency(utang_piutang.utang_due_date_not_yet) }}</h5>
                  <h5 class="fw-bold mb-0">Belum Jatuh Tempo</h5>
                </router-link>
                <span class="text-primary ml-1 link-hover" style="cursor: pointer;" @click.stop="downloadData(utang_piutang.utang_due_date_not_yet_data, 'utang')">Download</span>
              </div>
              <div class="d-flex text-decoration-none">
                <router-link :to="{ name: 'debt.index', query: { from: $route.name, type: 'Utang', period: 1 } }" target="_blank"
                class="flex-grow-1 text-dark d-flex justify-content-between link-hover">
                  <h5 class="mb-1 ml-1">{{ formatCurrency(utang_piutang.utang_due_date_less_than_14_days) }}</h5>
                  <h5 class="fw-bold text-dark mb-0">Lewat Jatuh Tempo < 14 Hari</h5>
                </router-link>
                <span class="text-primary ml-1 link-hover" style="cursor: pointer;" @click.stop="downloadData(utang_piutang.utang_due_date_less_than_14_data, 'utang')">Download</span>
              </div>
              <div class="d-flex text-decoration-none">
                <router-link class="flex-grow-1 text-dark d-flex justify-content-between link-hover"
                  :to="{ name: 'debt.index', query: { from: $route.name, type: 'Utang', period: 2 } }" target="_blank">
                  <h5 class="mb-1 ml-1">{{ formatCurrency(utang_piutang.utang_due_date_more_than_14_days) }}</h5>
                  <h5 class="fw-bold text-dark mb-0">Lewat Jatuh Tempo 14 - 30 Hari</h5>
                </router-link>
                <span class="text-primary ml-1 link-hover" style="cursor: pointer;" @click.stop="downloadData(utang_piutang.utang_due_date_more_than_14_data, 'utang')">Download</span>
              </div>
              <div class="d-flex text-decoration-none">
                <router-link class="flex-grow-1 text-dark d-flex justify-content-between link-hover"
                  :to="{ name: 'debt.index', query: { from: $route.name, type: 'Utang', period: 3 } }" target="_blank">
                  <h5 class="mb-1 ml-1">{{ formatCurrency(utang_piutang.utang_due_date_more_than_30_days) }}</h5>
                  <h5 class="fw-bold text-dark mb-0">Lewat Jatuh Tempo > 30 Hari</h5>
                </router-link>
                <span class="text-primary ml-1 link-hover" style="cursor: pointer;" @click.stop="downloadData(utang_piutang.utang_due_date_more_than_30_data, 'utang')">Download</span>
              </div>
            </div>

            <!-- Jatuh Tempo -->
            <div class="mb-1">
              <div class="tooltip-wrapper" @mouseenter="showTooltip.utang_due = true"
                @mouseleave="showTooltip.utang_due = false">
                <h6>Jatuh Tempo <feather-icon icon="AlertCircleIcon" /></h6>
                <Transition name="fade">
                  <div v-if="showTooltip.utang_due" id="talkbubble">
                    <div class="content-tooltip">
                      Utang yang Jatuh Tempo di periode {{ moment(filterDate.from).format("DD MMM YYYY") }} - {{
                      moment(filterDate.to).format("DD MMM YYYY") }}
                    </div>
                  </div>
                </Transition>
              </div>
              <b-progress :value="utang_piutang.utang_due_date_percentage" max="100" height="8px" variant="danger"
                class="mt-25 mb-25" style="background-color: #ffe5d3" />
              <h4 class="text-left fw-bold text-dark">
                {{ formatCurrency(utang_piutang.utang_due_date) }}
              </h4>
            </div>

            <div class="mb-1">
              <div class="tooltip-wrapper" @mouseenter="showTooltip.utang_period = true"
                @mouseleave="showTooltip.utang_period = false">
                <h6>Transaksi Saat Ini <feather-icon icon="AlertCircleIcon" /></h6>
                <Transition name="fade">
                  <div v-if="showTooltip.utang_period" id="talkbubble">
                    <div class="content-tooltip">
                      Transaksi Utang yang terjadi di periode {{ moment(filterDate.from).format("DD MMM YYYY") }}
                      - {{
                      moment(filterDate.to).format("DD MMM YYYY") }}
                    </div>
                  </div>
                </Transition>
              </div>
              <b-progress :value="utang_piutang.utang_by_period_percentage" max="100" height="8px" variant="danger"
                class="mt-25 mb-25" style="background-color: #ffe5d3" />
              <h4 class="text-left fw-bold text-dark">
                {{ formatCurrency(utang_piutang.utang_by_period) }}
              </h4>
            </div>
          </b-card>
          <!-- PIUTANG -->
          <b-card class="mb-0 border-10 p-2">
            <h2 class="text-dark fw-bold-700">Piutang</h2>

            <!-- Total Piutang -->
            <div class="mb-1">
              <div class="tooltip-wrapper" @mouseenter="showTooltip.piutang_total = true"
                @mouseleave="showTooltip.piutang_total = false">
                <h6>Total Kumulatif <feather-icon icon="AlertCircleIcon" /></h6>
                <Transition name="fade">
                  <div v-if="showTooltip.piutang_total" id="talkbubble">
                    <div class="content-tooltip">
                      Akumulasi Piutang sampai dengan tanggal {{ moment(filterDate.to).format("DD MMM YYYY") }}
                    </div>
                  </div>
                </Transition>
              </div>
              <b-progress :value="utang_piutang.piutang_total_percentage" max="100" height="8px" variant="success"
                class="mt-25 mb-25" style="background-color: #e2fbd7" />
              <h4 class="text-left fw-bold text-dark">
                {{ formatCurrency(utang_piutang.piutang_total) }}
              </h4>
              <div class="d-flex text-decoration-none">
                <router-link :to="{ name: 'debt.index', query: { from: $route.name, type: 'Piutang', period: 4 } }"
                  target="_blank" class="flex-grow-1 text-dark d-flex justify-content-between link-hover">
                  <h5 class="mb-1 ml-1">{{ formatCurrency(utang_piutang.piutang_due_date_not_yet) }}</h5>
                  <h5 class="fw-bold text-dark mb-0">Belum Jatuh Tempo</h5>
                </router-link>
                <span class="text-primary ml-1 link-hover" style="cursor: pointer;" @click.stop="downloadData(utang_piutang.piutang_due_date_not_yet_data, 'piutang')">Download</span>
              </div>
              <div class="d-flex text-decoration-none">
                <router-link class="flex-grow-1 text-dark d-flex justify-content-between link-hover"
                  :to="{ name: 'debt.index', query: { from: $route.name, type: 'Piutang', period: 1 } }" target="_blank">
                  <h5 class="mb-1 ml-1">{{ formatCurrency(utang_piutang.piutang_due_date_less_than_14_days) }}</h5>
                  <h5 class="fw-bold text-dark mb-0">Lewat Jatuh Tempo < 14 Hari</h5>
                </router-link>
                <span class="text-primary ml-1 link-hover" style="cursor: pointer;" @click.stop="downloadData(utang_piutang.piutang_due_date_less_than_14_data,'piutang')">Download</span>
              </div>
              <div class="d-flex text-decoration-none">
                <router-link class="flex-grow-1 text-dark d-flex justify-content-between link-hover"
                  :to="{ name: 'debt.index', query: { from: $route.name, type: 'Piutang', period: 2 } }" target="_blank">
                  <h5 class="mb-1 ml-1">{{ formatCurrency(utang_piutang.piutang_due_date_more_than_14_days) }}</h5>
                  <h5 class="fw-bold text-dark mb-0">Lewat Jatuh Tempo 14 - 30 Hari</h5>
                </router-link>
                <span class="text-primary ml-1 link-hover" style="cursor: pointer;" @click.stop="downloadData(utang_piutang.piutang_due_date_more_than_14_data, 'piutang')">Download</span>
              </div>
              <div class="d-flex text-decoration-none">
                <router-link class="flex-grow-1 text-dark d-flex justify-content-between link-hover"
                  :to="{ name: 'debt.index', query: { from: $route.name, type: 'Piutang', period: 3 } }" target="_blank">
                  <h5 class="mb-1 ml-1">{{ formatCurrency(utang_piutang.piutang_due_date_more_than_30_days) }}</h5>
                  <h5 class="fw-bold text-dark mb-0">Lewat Jatuh Tempo > 30 Hari</h5>
                </router-link>
                <span class="text-primary ml-1 link-hover" style="cursor: pointer;" @click.stop="downloadData(utang_piutang.piutang_due_date_more_than_30_data, 'piutang')">Download</span>
              </div>
            </div>

            <!-- Jatuh Tempo -->
            <div class="mb-1">
              <div class="tooltip-wrapper" @mouseenter="showTooltip.piutang_due = true"
                @mouseleave="showTooltip.piutang_due = false">
                <h6>Jatuh Tempo <feather-icon icon="AlertCircleIcon" /></h6>
                <Transition name="fade">
                  <div v-if="showTooltip.piutang_due" id="talkbubble">
                    <div class="content-tooltip">
                      Piutang yang Jatuh Tempo di periode {{ moment(filterDate.from).format("DD MMM YYYY") }} - {{
                      moment(filterDate.to).format("DD MMM YYYY") }}
                    </div>
                  </div>
                </Transition>
              </div>
              <b-progress :value="utang_piutang.piutang_due_date_percentage" max="100" height="8px" variant="success"
                class="mt-25 mb-25" style="background-color: #e2fbd7" />
              <h4 class="text-left fw-bold text-dark">
                {{ formatCurrency(utang_piutang.piutang_due_date) }}
              </h4>
            </div>

            <div class="mb-1">
              <div class="tooltip-wrapper" @mouseenter="showTooltip.piutang_period = true"
                @mouseleave="showTooltip.piutang_period = false">
                <h6>Transaksi Saat Ini <feather-icon icon="AlertCircleIcon" /></h6>
                <Transition name="fade">
                  <div v-if="showTooltip.piutang_period" id="talkbubble">
                    <div class="content-tooltip">
                      Transaksi Piutang yang terjadi di periode {{ moment(filterDate.from).format("DD MMM YYYY")
                      }} - {{
                      moment(filterDate.to).format("DD MMM YYYY") }}
                    </div>
                  </div>
                </Transition>
              </div>
              <b-progress :value="utang_piutang.piutang_by_period_percentage" max="100" height="8px" variant="success"
                class="mt-25 mb-25" style="background-color: #e2fbd7" />
              <h4 class="text-left fw-bold text-dark">
                {{ formatCurrency(utang_piutang.piutang_by_period) }}
              </h4>
            </div>
          </b-card>
        </div>
      </div>

      <div v-if="isLoading" class="loading-overlay">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
        <div class="mt-1">
          <h4>Loading data...</h4>
        </div>
      </div>
      <ModalCustomerFinancial :dataCustomer="merchantData.customersData" :download="downloadCustomers" />
    </div>
  </template>

<script>
import { BAvatar, BBadge, BButton, BCard, BCardHeader, BCol, BCollapse, BFormSelect, BIcon, BIconChevronRight, BProgress, BRow, BSpinner, VBToggle } from 'bootstrap-vue'
import moment from "moment";
import ModalCustomerFinancial from '@/components/Financial/ModalCustomerFinancial.vue';
import * as XLSX from "xlsx";

export default {
  name: "FinancialHealth",
  components: {
    BCard,
    BBadge,
    BProgress,
    BRow,
    BCol,
    BSpinner,
    BFormSelect,
    BAvatar,
    BCollapse,
    VBToggle,
    BIconChevronRight,
    BCardHeader,
    BButton,
    BIcon,
    ModalCustomerFinancial
  },
  props: {
    filterDate: {
      type: Object,
      default: () => ({ from: null, to: null })
    },
    filter: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showTooltip: {
        utang_total: false,
        utang_due: false,
        utang_period: false,
        piutang_total: false,
        piutang_due: false,
        piutang_period: false,
        customers_data: false
      },
      utang_piutang: {
        utang_total: 0,
        utang_total_percentage: 0,
        utang_due_date: 0,
        utang_due_date_percentage: 0,
        utang_due_date_more_than_14_days: 0,
        utang_due_date_more_than_30_days: 0,
        utang_due_date_less_than_14_days: 0,
        utang_due_date_not_yet: 0,
        utang_by_period: 0,
        utang_by_period_percentage: 0,
        piutang_total: 0,
        piutang_total_percentage: 0,
        piutang_due_date: 0,
        piutang_due_date_percentage: 0,
        piutang_due_date_more_than_14_days: 0,
        piutang_due_date_more_than_30_days: 0,
        piutang_due_date_less_than_14_days: 0,
        piutang_due_date_not_yet: 0,
        piutang_by_period: 0,
        piutang_by_period_percentage: 0
      },
      expandedTipe: [], // array to track expanded tipe_pembayaran
      expandedJenis: {}, // object to track expanded jenis_pembayaran per tipe
      isLoading: false,
      selected_branch: null,
      options: [],
      merchantData: {
        total_invoice: null,
        merchant: null,
        periode: null,
        pelangganTidakTerdaftar: null,
        pelangganTerdaftar: 0,
        totalPelangganTerdaftar: 0,
        persenPelangganAktif: 0,
        sales: null,
        stock: null,
        grossProfit: null,
        persenGrossProfit: null,
        cost: null,
        netProfit: null,
        persenNetProfit: null,
        groupedPayments: {},
        totalValuePelangganTerdaftar: null,
        totalValuePelangganTidakTerdaftar: null,
        customersData: [],
        // inventory_cash_value: null,
      },
    }
  },
  methods: {
    openModalCustomerFinancial() {
      this.$bvModal.show("modal-customer-financial")
    },
    openInNewTab(e, query) {
      const r = this.$router.resolve({
        name: 'debt.index',
        query
      });

      if (e.ctrlKey || e.metaKey) {
        window.open(r.href, '_blank');
      } else {
        this.$router.push(r.location);
      }
    },
    downloadData(data, type = 'utang') {
      if (!Array.isArray(data)) {
        this.$bvToast.toast("Data tidak tersedia untuk diunduh.", {
          title: "Peringatan",
          variant: "warning",
          solid: true,
        });
        return;
      }

      const today = new Date();

      function getLatestPaymentDate(payments) {
        if (!payments || !payments.length) return "";

        const latest = payments
          .map(p =>
            new Date(p.payment_date) > new Date(p.created_at)
              ? new Date(p.payment_date)
              : new Date(p.created_at)
          )
          .sort((a, b) => b - a)[0];

        return latest ? latest.toISOString().slice(0, 10) : "";
      }


      // HEADER FOR UTANG
      const headerUtang = [
        "Nama Supplier",
        "Sisa Hutang Aktif",
        "Hutang Jatuh Tempo",
        "Tanggal Jatuh Tempo",
        "Sudah Di Bayar",
        "Tanggal Pembayaran",
        "Merchant",
        "Cabang",
        "Keterangan"
      ];

      // HEADER FOR PIUTANG
      const headerPiutang = [
        "Nama Konsumen",
        "No Invoice",
        "Tanggal Invoice",
        "Sisa Piutang Aktif",
        "Piutang Jatuh Tempo",
        "Tanggal Jatuh Tempo",
        "Sudah Di Bayar",
        "Tanggal Pembayaran",
        "Merchant",
        "Cabang",
        "Keterangan"
      ];

      const header = type === "piutang" ? headerPiutang : headerUtang;
      const rows = data.map(d => {
        const dueDate = new Date(d.due_date);
        const sisaAktif = dueDate > today ? d.unpaid : 0;
        const jatuhTempo = dueDate <= today ? d.unpaid : 0;

        if (type === "piutang") {
          return [
            d.subject_name || "",
            d?.invoice_number ?? "",
            d?.invoice_date ? moment(d.invoice_date).format("YYYY/MM/DD") : "",
            sisaAktif || 0,
            jatuhTempo || 0,
            d.due_date || "",
            d.paid || 0,
            getLatestPaymentDate(d.payments),
            d.merchant || "",
            d.branch || "",
            d.due_date_info || ""
          ];
        }

        return [
          d.subject_name || "",
          sisaAktif || 0,
          jatuhTempo || 0,
          d.due_date || "",
          d.paid || 0,
          getLatestPaymentDate(d.payments),
          d.merchant || "",
          d.branch || "",
          d.due_date_info || ""
        ];
      });
      const worksheetData = [header, ...rows];

      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

      // Auto-fit column widths
      const colWidths = header.map((h, i) => {
        let maxLen = h.length;

        rows.forEach(row => {
          const cell = row[i] ? row[i].toString() : "";
          if (cell.length > maxLen) maxLen = cell.length;
        });

        return { wch: maxLen + 2 };
      });

      worksheet['!cols'] = colWidths;

      // Build workbook and save
      const workbook = XLSX.utils.book_new();
      const sheetName = type === "piutang" ? "Piutang" : "Utang";
      workbook.SheetNames.push(sheetName);
      workbook.Sheets[sheetName] = worksheet;
      const fileName = type === "piutang" ? "piutang.xlsx" : "utang.xlsx";
      XLSX.writeFile(workbook, fileName);
    },
   downloadCustomers() {
      const customers = this.merchantData.customersData || [];

      const worksheetData = [
        ["Name", "No Telefon", "Nama Alias", "Alamat", "Tipe", "Tanggal Terakhir Order"],
        ...customers.map(c => [
          c.name || "",
          c.phone_number || "",
          c.nama_alias || "",
          c.address || "",
          c.customer_type || "",
          c.last_order_date || "",
        ])
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");
      XLSX.writeFile(workbook, "customers.xlsx");
    },
    moment,
    toggleTipe(tipeName) {
      if (this.expandedTipe.includes(tipeName)) {
        this.expandedTipe = this.expandedTipe.filter((t) => t !== tipeName);
      } else {
        this.expandedTipe.push(tipeName);
      }
    },
    toggleJenis(tipeName, jenisName) {
      if (!this.expandedJenis[tipeName]) {
        this.$set(this.expandedJenis, tipeName, []);
      }
      const list = this.expandedJenis[tipeName];
      if (list.includes(jenisName)) {
        this.expandedJenis[tipeName] = list.filter((j) => j !== jenisName);
      } else {
        this.expandedJenis[tipeName].push(jenisName);
      }
    },
    isJenisExpanded(tipeName, jenisName) {
      return (
        this.expandedJenis[tipeName] &&
        this.expandedJenis[tipeName].includes(jenisName)
      );
    },
    async fetchDashboard() {
      try {
        this.isLoading = true
        const userData = JSON.parse(localStorage.getItem('userData'))
        this.merchantData = {
          ...this.merchantData,
          merchant: userData.merchant?.name,
        }
        const res = await this.$http.get("/financial-health", {
          params: {
            branch_uuid: userData.branch.uuid,
            ...this.filter
          },
        })
        const data = res.data
        this.$emit("update:filterDate", data.report_date)
        this.utang_piutang = data.utang_piutang
        this.merchantData = {
          ...this.merchantData,
          merchant: userData.merchant?.name,
          total_invoice: data.total_invoice,
          groupedPayments: data.grouped_payments,
          pelangganTidakTerdaftar: data.no_customer,
          pelangganTerdaftar: data.unique_customers,
          totalPelangganTerdaftar: data.total_customers,
          persenPelangganAktif: data.total_customers > 0
            ? Math.round((data.unique_customers / data.total_customers) * 100)
            : 0,
          totalValuePelangganTerdaftar: data.unique_customers_value,
          totalValuePelangganTidakTerdaftar: data.no_customer_value,
          sales: data.omset,
          stock: data.stock,
          grossProfit: data.gross_profit ? data.gross_profit : 0,
          persenGrossProfit: Math.round(data.gross_profit_percentage * 100),
          cost: data.total_payments,
          netProfit: data.gross_profit - data.total_payments,
          persenNetProfit: data.omset > 0
            ? Math.round(((data.gross_profit - data.total_payments) / data.omset) * 100)
            : 0,
          customersData: data.customersData,
          // inventory_cash_value: data.inventory_cash_value
        }
      } catch (err) {
        console.error("Error fetching dashboard:", err)
      } finally {
        this.isLoading = false
      }
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount)
    },
    formatNumber(num) {
      if (num === null || num === undefined) return "0"
      return num.toLocaleString("id-ID")
    }
  },
  
}
</script>

<style scoped>
/* .dashboard-wrapper,
  .dashboard-wrapper * {
    color: #000 !important;
  } */

/* .dashboard-wrapper {
  font-family: 'Montserrat', Helvetica, Arial, serif;
  color: #0f172a;
  line-height: 1.6;
} */

.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.content-tooltip {
  font-size: 14px;
  color: #e2e8f0;
  margin-bottom: 0px !important;
  padding: 0px !important;
}

.grouped-payments {
  color: #000;
}

.transition {
  transition: transform 0.2s ease;
}

.rotate-90 {
  transform: rotate(90deg);
}

/* ===== Cards ===== */
.header-card,
.metric-card,
.metric-section {
  background: #fff;
  border: none;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.card-body {
  padding: 0 !important;
}

.header-card {
  padding: 1.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

.metric-section {
  padding: 1.5rem;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);
  position: relative;
}

.metric-card {
  padding: 1rem 1.25rem;
  display: flex;
  min-height: 108px;
  color: black;
}

/* ===== Header ===== */
.header-card h1 {
  font-size: 1.7rem;
  font-weight: 700;
  color: #2e3a59;
}

.header-card .badge {
  background: #f1f5f9;
  color: #475569;
  font-weight: 600;
  font-size: 0.95rem;
}

/* ===== Metric Cards ===== */
.metric-label {
  font-size: 1.3rem;
  font-weight: 600;
  color: #64748b;
  display: block;
}

.metric-label span {
  display: inline-block;
  min-width: 6rem;
  /* just enough to fit your largest number */
  text-align: right;
}

.metric-value {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0.2rem 0;
  color: #0f172a;
}

/* ===== Section titles ===== */
.section-title {
  font-weight: 700;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
}

.metric-section span {
  font-size: 1rem;
  color: #475569;
}

.metric-section .font-weight-bold {
  font-size: 1.2rem;
  color: #0f172a;
}

.metric-section .badge {
  font-weight: 600;
  font-size: 0.95rem;
  border: none;
  padding: 0.4rem 0.8rem;
  border-radius: 9999px;
}

/* ===== Customer Metrics Grid ===== */
.customer-metrics-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.utang-piutang-section {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

@media (min-width: 768px) {
  .customer-metrics-grid {
    grid-template-columns: repeat(2, 1fr);
    /* tablet: 2 columns */
  }

  .utang-piutang-section {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .b-card-header {
    padding: 0.4rem 0.5rem !important;
  }

  h3,
  h4,
  h5 {
    font-size: 0.9rem !important;
  }

  .ml-1 {
    margin-left: 0.3rem !important;
  }

  .pl-2,
  .pl-3 {
    padding-left: 0.75rem !important;
  }

  .text-right {
    font-size: 0.9rem;
  }

  small {
    font-size: 1.1rem !important;
  }
}

@media (min-width: 1200px) {
  .customer-metrics-grid {
    grid-template-columns: repeat(3, 1fr);
    /* desktop: 3 columns */
  }

  .utang-piutang-section {
    grid-template-columns: repeat(2, 1fr);
  }
}

.customer-metrics-grid .metric-card {
  min-height: 130px;
}

/* ===== Overlay ===== */
.loading-overlay {
  position: absolute;
  /* relative to dashboard-wrapper */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  z-index: 2000;
}

.blurred {
  filter: blur(2px);
  pointer-events: none;
}

.badge-white-text {
  color: #fff !important;
}

#talkbubble {
  position: absolute;
  top: -40%;
  left: calc(100% + 2px);
  transform: translateY(-50%);
  width: 320px;
  background: #334155;
  border-radius: 10px;
  padding: 1rem;
  z-index: 10;
}

#talkbubble .title {
  color: #fff;
  font-size: 16px;
  margin-bottom: 10px;
}

#talkbubble .content-tooltip {
  font-size: 14px;
  color: #e2e8f0;
  margin-bottom: 0px !important;
  padding: 0px !important;
}

#talkbubble::before {
  content: "";
  position: absolute;
  top: 77%;
  left: -16px;
  transform: translateY(-50%);
  border-width: 12px;
  border-style: solid;
  border-color: transparent #334155 transparent transparent;
}


.content-tooltip.scrollable-tooltip {
  max-height: 200px;
  /* 👈 adjust height as needed */
  overflow-y: auto;
  /* 👈 makes it scrollable */
  padding-right: 6px;
  /* optional: prevents scrollbar overlap */
}

.link-hover:hover {
  color: #0066ff !important;
  opacity: 0.5;
  transition: all 0.2s ease;
}
</style>
